<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { storeToRefs } from "pinia";
import { onUnmounted } from "vue";

import PlusWhite from "#/assets/iconsDynamic/PlusWhite.vue";
import { useCardStore } from "#/store/card";
import { useDecorationStore } from "#/store/decoration";
import CardMain from "../cardMain/CardMain.vue";

const props = defineProps<{
	qr_menu?: boolean;
	closeCurrentCard: any;
	openCurrentCard: any;
}>();

const { t } = useTranslation();
const cardStore = useCardStore();
const { isUpSale, dataUpSale } = storeToRefs(cardStore);
const decor = useDecorationStore().screen("main");

const goClose = () => {
	isUpSale.value = false;
};

onUnmounted(() => {
	dataUpSale.value = null;
});
</script>

<template>
	<div class="recommendation_wrapper" v-bind="decor.bind('recommendation')">
		<div class="recommendation_header">
			<p class="header_title">{{ t(`recommendation.modal.title`) }}</p>
			<div class="header_close_recommendation" @click="goClose">
				<PlusWhite class="close_icon" />
			</div>
		</div>
		<div class="recommendation_info">
			<CardMain
				v-for="(card) in dataUpSale"
				:data="card"
				:key="card.id"
				:parent="card.id"
				:is_group="false"
				:is_product="true"
				:qr_menu="props.qr_menu"
				class="card"
				:activeTags="[]"
				:isLoading="false"
				:closeCurrentCard="closeCurrentCard"
				:takeCurrentCard="() => openCurrentCard(card.id, true)"
				decoration="main"
				v-bind="decor.bind('card')"
			/>
		</div>
	</div>
</template>

<style lang="scss" scoped>
    @use './recommendation.scss';
</style>
